import { Suspense } from "react"
import { makeStyles } from "tss-react/mui"
import { useNavigate } from "react-router-dom"
import { Grid, Tooltip, Typography } from "@mui/material"
import { DashboardCardSkeleton } from "../../../../dashboards/components/DashboardCardSkeleton"
import { QueryErrorBoundary } from "../../../../../core/api/components/QueryErrorBoundary"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { CardUiParams } from "../../../../dashboards/components/DashboardCard"
import { MerchantHomeQuery, fetchTodaysOffers } from "../merchantHomeApi"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { useMerchant } from "../../../../merchants/merchantHooks"

const useStyles = makeStyles()((theme) => ({
    container: {
        color: theme.palette.tailwind.slate[700],
        background: "#CEF8DB",
        borderRadius: "0.5rem",
        textAlign: "center",
        maxWidth: CardUiParams.WIDTH,
        padding: "1.5rem 1rem",
        cursor: "pointer",
        [theme.breakpoints.down("xl")]: {
            width: CardUiParams.WIDTH_SM,
        },
    },
}))

export function TodaysOffersContent() {
    const { merchantId } = useMerchant()
    const { classes } = useStyles()
    const navigate = useNavigate()

    const { data } = useApiQuery(fetchTodaysOffers, {
        queryName: MerchantHomeQuery.TODAYS_OFFERS,
        dependencies: {
            merchantId,
        },
        suspense: true,
        useErrorBoundary: true,
        refetchInterval: 30000,
    })

    return (
        <LocalizedStrict id="merchant-home-todays-offers-tooltip" attrs={{ title: true }}>
            <Tooltip arrow title="Number of active offers for today">
                <Grid
                    container
                    flexDirection="column"
                    gap={2}
                    className={classes.container}
                    onClick={() => {
                        // navigate()
                    }}
                >
                    <LocalizedStrict id="merchant-home-todays-offers">
                        <Typography variant="h6">Todays offers</Typography>
                    </LocalizedStrict>
                    <Typography variant="h3" fontWeight={500}>
                        {data?.marketing?.numberOfTodaysOffers || 0}
                    </Typography>
                </Grid>
            </Tooltip>
        </LocalizedStrict>
    )
}

export function TodaysOffersCard() {
    return (
        <QueryErrorBoundary>
            <Suspense
                fallback={
                    <>
                        <DashboardCardSkeleton isSmall />
                    </>
                }
            >
                <TodaysOffersContent />
            </Suspense>
        </QueryErrorBoundary>
    )
}
